export type ProductMediaType = 'image' | 'video';

const VIDEO_EXTENSIONS = new Set(['.mp4', '.webm', '.mov', '.m4v']);

function extensionFromUrl(value: string): string {
  const withoutQuery = value.split(/[?#]/, 1)[0] || '';
  const dotIndex = withoutQuery.lastIndexOf('.');
  if (dotIndex === -1) return '';
  return withoutQuery.slice(dotIndex).toLowerCase();
}

export function getProductMediaType(src: string | null | undefined): ProductMediaType | null {
  const trimmed = src?.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('data:video/')) return 'video';
  if (trimmed.startsWith('data:image/')) return 'image';
  return VIDEO_EXTENSIONS.has(extensionFromUrl(trimmed)) ? 'video' : 'image';
}

export function isProductVideoUrl(src: string | null | undefined): boolean {
  return getProductMediaType(src) === 'video';
}
